var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":"/categories"}},[_c('div',{staticClass:"page plug",style:({ backgroundImage: `url(${require('@/assets/img/EAJ_GT_LAVAGNA.jpg')})` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }